import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    useTheme,
    Typography,
    Divider,
    Menu,
    MenuItem,
    AppBar,
    Toolbar,
    Container,
    Dialog,
    DialogTitle,
    DialogContent,
    Tooltip,
    Popover,
} from '@mui/material';
import {
    Menu as MenuIcon,
    Dashboard as DashboardIcon,
    Assessment as AssessmentIcon,
    Settings as SettingsIcon,
    ChevronLeft as ChevronLeftIcon,
} from '@mui/icons-material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { tokens } from '../../../../theme';

import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Helmet } from 'react-helmet';

import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import { useProject } from '../../../../context/ProjectContext';
import config from '../../../../config';
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const Sidebar011 = ({ isPlanningOpen, setIsPlanningOpen, isSettingsOpen, setIsSettingsOpen }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const { handleLogout } = useProject();
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [openSettings, setOpenSettings] = useState(false);
    const [isInfoOpen, setIsInfoOpen] = useState(false);
    const projecturl = "esid-25-011";
    const projectname = "Lummen";
    const menuItems = [
        {
            title: 'Dashboard',
            icon: <DashboardIcon fontSize="medium" />,
            path: `/${projecturl}/dashboard`,
            type: 'route',
        },
        {
            title: 'Reports',
            icon: <AssessmentIcon fontSize="medium" />,
            path: `/${projecturl}/reports`,
            type: 'route',
        },
        {
            title: 'Planning',
            icon: <CalendarMonthIcon fontSize="medium" />,
            type: 'modal',
        },
        {
            title: 'Settings',
            icon: <SettingsIcon fontSize="medium" />,
            type: 'modal',
        },
    ];

    const clickItem = (item) => {
        console.log(item);
        if (item.title === 'Planning') {
            setIsPlanningOpen(!isPlanningOpen);
        } else if (item.title === 'Settings') {
            setIsSettingsOpen(!isSettingsOpen);
        } else {
            navigate(item.path);
        }
    }
    const drawerWidth = 240;
    const logout = async () => {
        await handleLogout();
        localStorage.removeItem('selectedProject');
        localStorage.removeItem('allowedPages');
        localStorage.removeItem('allowedProjects');
        localStorage.removeItem('all_roles');
        navigate('/signin');
    }
    const handleOpenSettings = () => setOpenSettings(true);

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const getPageTitle = () => {
        console.log("STAGE", config.meta.STAGE);
        switch (config.meta.STAGE) {
            case 'prod':
                return `Endustries - ${projectname}`;
            case 'uat':
                return `Endustries - ${projectname} [UAT]`;
            default:
                return `Endustries - ${projectname} [DEV ${config.meta.VERSION}]`;
        }
    };

    return (
        <Box >
            <AppBar position="static" enableColorOnDark sx={{
                boxShadow: 0,
                //bgcolor: "#e0e0e0",
                bgcolor: "rgba(72,63,94,0.1)",
                //bgcolor: "rgba(63,124,128,0.2)",
                //bgcolor:colors.entras_purple[100],
                backgroundImage: 'none',
                width: "100%", borderRadius: 2,
                height: 45,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                alignContent: "center",
                alignSelf: "center"
            }}>
                <Container maxWidth="100%">
                    <Toolbar disableGutters>
                        <a href="/" style={{ textDecoration: 'none' }}>
                            <img
                                src="/assets/Endustries-positief.svg"  // Update the path to include "assets/"
                                alt="Logo"
                                height={15}
                                style={{ cursor: 'pointer', marginTop: 4, marginLeft: 40 }}
                            />

                        </a>
                        <Helmet>
                            <title>{getPageTitle()}</title>
                        </Helmet>
                        <div className={`testapp ${config.meta.VERSION} ${config.meta.STAGE}`}>TEST</div>
                        {isInfoOpen && (
                            <Popover
                                open={isInfoOpen}
                                anchorEl={document.querySelector('button[aria-label="info"]')} // Reference to info button
                                onClose={() => setIsInfoOpen(false)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <Box
                                    sx={{
                                        p: 2,
                                        bgcolor: 'background.paper',
                                        borderRadius: 1,
                                        boxShadow: 1,
                                        minWidth: 200,
                                    }}
                                >
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        Application Info
                                    </Typography>
                                    {/* add user info */}
                                    <Typography variant="body2">
                                        User: {localStorage.getItem('useremail')}
                                    </Typography>
                                    <Divider sx={{ my: 1 }} />
                                    <Typography variant="body2">
                                        Version: {config.meta.VERSION}
                                    </Typography>
                                    <Typography variant="body2">
                                        Stage: {config.meta.STAGE}
                                    </Typography>
                                    <Typography variant="body2">
                                        Release Date: {config.meta.RELEASE_DATE || 'Not specified'}
                                    </Typography>
                                    <Typography variant="body2">
                                        Environment: {process.env.NODE_ENV}
                                    </Typography>
                                </Box>
                            </Popover>
                        )}


                        <Box sx={{ flexGrow: 1, flexDirection: "row", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>

                            <a href="/" style={{ textDecoration: 'none' }}>
                                <img
                                    src="/assets/poweredbyentras-paars.png"  // Update the path to include "assets/"
                                    alt="Logo"
                                    height={30}
                                    style={{
                                        cursor: 'pointer',
                                        marginRight: 20, marginTop: 4,
                                        //opacity: 0.5
                                    }}
                                />

                            </a>
                        </Box>

                        <Box sx={{ flexGrow: 0, flexDirection: "row", display: "flex" }}>
                            <IconButton
                                onClick={() => setIsInfoOpen(!isInfoOpen)}
                                aria-label="info"  // Add this line
                            >
                                <InfoOutlinedIcon fontSize="inherit"
                                    sx={{ color: colors.grey[100] }} />
                            </IconButton>
                            <Divider sx={{}} orientation="vertical" variant="middle" flexItem />

                            <IconButton
                                href='https://entras.be/helpdesk/'
                                target="_blank" // Opens the link in a new tab
                                rel="noopener noreferrer"
                            >
                                <HelpOutlineOutlinedIcon fontSize="inherit"
                                    sx={{ color: colors.grey[100] }} />
                            </IconButton>

                            <Divider sx={{}} orientation="vertical" variant="middle" flexItem />

                            <IconButton
                                onClick={() => setIsSettingsOpen(!isSettingsOpen)}
                            >
                                <SettingsOutlinedIcon fontSize="inherit" sx={{ color: colors.grey[100] }} />

                            </IconButton>
                            <Divider sx={{}} orientation="vertical" variant="middle" flexItem />
                            <IconButton
                                onClick={() => logout()}
                                rel="noopener noreferrer"
                            >
                                <LogoutOutlinedIcon fontSize="inherit" sx={{ color: colors.grey[100] }} />

                            </IconButton>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                        <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            <Drawer
                variant="permanent"
                sx={{
                    width: 45,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: isOpen ? drawerWidth : 45,
                        boxSizing: 'border-box',
                        //borderRadius: 5,
                        //borderTopRightRadius: 4,
                        //borderTopLeftRadius: 4,
                        overflow: "hidden",
                        backgroundColor: colors.entras_purple[100],
                        transition: theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                    },
                }}
            >

                <Box sx={{
                    height: "100%", justifyContent: "center",
                    alignItems: "center",
                    display: "flex", alignContent: "center",
                    alignSelf: "center"
                }}>
                    <List>
                        {menuItems.map((item, index) => {
                            const isRouteItem = item.type === 'route';
                            const isRouteActive = isRouteItem && location.pathname === item.path;
                            const isModalActive =
                                item.title === 'Planning'
                                    ? isPlanningOpen
                                    : item.title === 'Settings'
                                        ? isSettingsOpen
                                        : false;
                            const firstModalIndex = menuItems.findIndex((m) => m.type === 'modal');

                            const backgroundColor = isRouteActive
                                ? colors.blueAccent[800]
                                : isModalActive
                                    ? 'rgba(255,255,255,0.16)'
                                    : 'transparent';
                            const hoverBackgroundColor = isRouteItem
                                ? colors.blueAccent[800]
                                : 'rgba(255,255,255,0.12)';

                            const iconColor = (isRouteActive || isModalActive)
                                ? colors.grey[100]
                                : colors.grey[900];

                            return (
                                <React.Fragment key={item.title}>
                                    {index === firstModalIndex && (
                                        <Divider
                                            sx={{
                                                my: 3,
                                                mx: 1,
                                                borderColor: 'rgba(255,255,255,0.2)',
                                            }}
                                        />
                                    )}
                                    <Tooltip title={item.title} placement="right">
                                        <ListItem
                                            button
                                            onClick={() => clickItem(item)}
                                            sx={{
                                                backgroundColor,
                                                '&:hover': {
                                                    backgroundColor: hoverBackgroundColor,
                                                },
                                                borderRadius: "100%",
                                                width: 30,
                                                height: 30,
                                                mt: 3,
                                                mb: 3,
                                                ml: 1,
                                                mr: 1,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                transition: theme.transitions.create(
                                                    ['background-color', 'transform'],
                                                    {
                                                        duration: theme.transitions.duration.shorter,
                                                    }
                                                ),
                                                transform: (isRouteActive || isModalActive) ? 'scale(1.05)' : 'scale(1)',
                                            }}
                                        >
                                            <ListItemIcon
                                                sx={{
                                                    color: iconColor,
                                                    justifyContent: "center",
                                                    minWidth: 0,
                                                    '&:hover': {
                                                        color: colors.grey[100],
                                                    },
                                                }}
                                            >
                                                {item.icon}
                                            </ListItemIcon>
                                        </ListItem>
                                    </Tooltip>
                                </React.Fragment>
                            );
                        })}
                    </List>
                </Box>
            </Drawer>
            {/* <Box
                sx={{
                    position: 'absolute',
                    bottom: 16,  // Adjust these values
                    right: 16,   // to position as needed
                    zIndex: 1,   // Ensure it stays above other content
                }}
            >
                <img
                    src="/assets/entras.svg"
                    alt="Logo"
                    width={250}
                    height={250}
                    style={{
                        opacity: 0.1,
                        cursor: 'pointer',
                    }}
                />
            </Box> */}
        </Box>
    );
};

export default Sidebar011;